import { createContext, Dispatch, useContext } from 'react';

import { SaveFn } from '../hooks/usePropertySave';
import { SetSourceModeFn } from '../hooks/usePropertySourceMode';
import { PropertySettingsAction, PropertySettingsState } from '../state';

export interface PropertySettingsContextValue {
	state: PropertySettingsState;
	dispatch: Dispatch<PropertySettingsAction>;
	isDirty: boolean;
	isListMode: boolean;
	propertyId: string;
	save: SaveFn;
	setSourceMode: SetSourceModeFn;
	goToProperty: (targetPropertyId: string) => void;
}

const PropertySettingsContext = createContext<PropertySettingsContextValue | null>(null);

export const PropertySettingsProvider = PropertySettingsContext.Provider;

export function usePropertySettings(): PropertySettingsContextValue {
	const ctx = useContext(PropertySettingsContext);
	if (!ctx) {
		throw new Error('usePropertySettings must be used within a PropertySettingsProvider');
	}
	return ctx;
}
